import { render } from "./AgendaView.vue?vue&type=template&id=d0836950&scoped=true"
import script from "./AgendaView.vue?vue&type=script&lang=js"
export * from "./AgendaView.vue?vue&type=script&lang=js"

import "./AgendaView.vue?vue&type=style&index=0&id=d0836950&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0836950"]])

export default __exports__